import { useState } from 'react';

export default function useToken() {
    const getToken = () => {
        const tokenString = localStorage.getItem('token');
        const userToken = JSON.parse(tokenString);
        return userToken?.token
    };

    const [token, setToken] = useState(getToken());

    const saveToken = userToken => {
        localStorage.setItem('token', JSON.stringify(userToken));
        // Nouvelle session : on purge la sélection persistée du dashboard pour
        // toujours repartir sur les valeurs par défaut (aujourd'hui, période préc.).
        localStorage.removeItem('dashStartDate');
        localStorage.removeItem('dashEndDate');
        localStorage.removeItem('dashComparison');
        setToken(userToken.token);
    };

    return {
        setToken: saveToken,
        token
    }
}